define(['bootstrap/carousel'], function (Carousel) {
    'use strict';

    return (config, element) => new Carousel(element);
});
